import React from "react";
import { Navigate } from "react-router-dom";

// ─────────────────────────────────────────────
// ProtectedRoute.jsx
//
// Wraps any route to protect it.
// - Not logged in       → redirect to /login
// - Wrong role          → redirect to /login
// - Correct role        → show the page
//
// Usage in AppRoutes.jsx:
//   <Route path="/admin/dashboard" element={
//     <ProtectedRoute allowedRoles={["admin", "super_admin"]}>
//       <Admin_dashboard />
//     </ProtectedRoute>
//   } />
// ─────────────────────────────────────────────
export default function ProtectedRoute({ children, allowedRoles = [] }) {
  const token = localStorage.getItem("token");

  const user = (() => {
    try { return JSON.parse(localStorage.getItem("user")); }
    catch { return null; }
  })();

  // Not logged in → go to login
  if (!token || !user) {
    return <Navigate to="/login" replace />;
  }

  // Wrong role → go to login
  if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    return <Navigate to="/login" replace />;
  }

  return children;
}